import { cloneRgObject } from "@project-rouge/rg-core";
const Brief2PipeProps = ({ brief, start = 0, count = 10 }) => {
	const pipePropsList = [];
	for (let i = start; i < start + count; i++) pipePropsList.push(Brief2PipePropsByIndex(brief, i));
	return pipePropsList;
};
function Brief2PipePropsByIndex(brief, i) {
	const zones = Object.keys(brief.zoneBriefs);
	const pipeProps = {
		obj: cloneRgObject(brief.obj),
		aggProps: {
			dataset: brief.dataset,
			face2FaceSeparation: brief.face2FaceSeparation,
			face2SideSeparation: brief.face2SideSeparation,
			zones: {},
			optimisePlots: brief.optimisePlots,
			unboundedTailor: brief.unboundedTailor
		}
	};
	const zoneBriefs = Object.entries(brief.zoneBriefs);
	for (const [id, zoneBrief] of zoneBriefs) {
		const aggZoneProps = {
			subdivisionSeed: i + zones.indexOf(id),
			skeletonTailorSeed: zoneBrief.useDefaultSkeletonPosition ? void 0 : i,
			floors: zoneBrief.floors,
			maxPlotCount: zoneBrief.buildings,
			unitMix: zoneBrief.unitMix,
			techSpaces: zoneBrief.technicalSpaces,
			disableTBranches: true,
			frozen: zoneBrief.frozen,
			siteBoundaryFactor: zoneBrief.siteBoundaryFactor,
			avoidNorthFactor: zoneBrief.avoidNorthFactor,
			avoidNorthRange: zoneBrief.avoidNorthRange,
			adjacencyFactor: zoneBrief.adjacencyFactor,
			facadeId: zoneBrief.facadeId,
			maxWingLength: zoneBrief.maxWingLength
		};
		pipeProps.aggProps.zones[id] = aggZoneProps;
		if (!zoneBrief.podium) continue;
		aggZoneProps.podium = {
			start: 0,
			count: zoneBrief.podium.replaceLevels,
			height: zoneBrief.podium.levelHeight
		};
	}
	return pipeProps;
}
export { Brief2PipeProps };

//# sourceMappingURL=index8.js.map